import React, { useEffect, useState } from "react";
import { analytics } from "@/mock";
import { analyticsApi } from "@/services/phase1Api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { toast } from "@/components/ui/sonner";

export const AnalyticsScreen = ({ session }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await analyticsApi.list(session);
        if (mounted) setItems(data);
      } catch {
        // ignore
      }
    })();

    return () => {
      mounted = false;
    };
  }, [session]);

  return (
    <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-center">
        <div>
          <div className="text-2xl font-semibold text-foreground">Analytics</div>
          <div className="mt-2 text-sm text-foreground/60">
            Client-side event log. Events are tracked locally and synced on integration.
          </div>
        </div>
        <Button
          variant="secondary"
          onClick={() => {
            analytics.clear();
            setItems([]);
            toast.message("Cleared", { description: "Analytics log cleared." });
          }}
          className="h-11 rounded-none border border-border bg-foreground/5 text-foreground hover:bg-foreground hover:text-background"
        >
          Clear
        </Button>
      </div>

      <Card className="mt-6 rounded-3xl border-border bg-foreground/5 p-4 backdrop-blur-2xl">
        <Table>
          <TableHeader>
            <TableRow className="border-border">
              <TableHead className="text-foreground/55">Event</TableHead>
              <TableHead className="text-foreground/55">Time</TableHead>
              <TableHead className="text-foreground/55">Payload</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.slice(0, 30).map((e) => (
              <TableRow key={e.id} className="border-border">
                <TableCell className="text-foreground">{e.name}</TableCell>
                <TableCell className="text-foreground/70">
                  {new Date(e.ts).toLocaleString()}
                </TableCell>
                <TableCell className="text-foreground/55">
                  <pre className="max-w-[560px] overflow-auto text-xs">
                    {JSON.stringify(e.payload, null, 2)}
                  </pre>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {!items.length ? (
          <div className="px-2 py-8 text-sm text-foreground/60">
            No events yet. Submit the Opportunity Score form or simulate booking.
          </div>
        ) : null}
      </Card>

      <div className="mt-6 text-xs text-foreground/45">
        Key funnel events are tracked client-side. Server-side tracking and CRM stage analytics available with full integration.
      </div>
    </div>
  );
};
